import { FieldPolicy, Reference } from '@apollo/client';

declare type KeyArgs = FieldPolicy<any>['keyArgs'];
// A basic field policy that uses options.args.{offset,limit} to splice
// the incoming data into the existing array. If your arguments are called
// something different (like args.{start,count}), feel free to copy/paste
// this implementation and make the appropriate changes.
// https://github.com/apollographql/apollo-client/blob/cbcf951256b22553bdb065dfa0d32c0a4ca804d3/src/utilities/policies/pagination.ts#L28

export function tableOffsetLimitPagination<T = Reference>(keyArgs?: KeyArgs): FieldPolicy<T[]> {
  return {
    keyArgs: keyArgs || false,
    merge(_existing, incoming) {
      return incoming;
    },
  };
}

export function offsetLimitPagination<T = Reference>(keyArgs: KeyArgs = false): FieldPolicy<{ nodes: T[] }> {
  return {
    keyArgs,
    merge(existing, incoming, { args }) {
      const mergedNodes = existing ? ((existing && existing.nodes) || []).slice(0) : [];

      if (args) {
        // Assume an offset of 0 if args.offset omitted.
        const offset = args?.args || args?.offset || args?.input?.offset || 0;
        for (let i = 0; i < incoming.nodes.length; ++i) {
          mergedNodes[offset + i] = incoming.nodes[i];
        }
      } else {
        mergedNodes.push.apply(mergedNodes, incoming.nodes);
      }

      return {
        ...existing,
        ...incoming,
        nodes: mergedNodes,
      };
    },
  };
}
